import { TipoMovimentacao } from "./processo-movimentacao";

export class MigracaoMovimentacao{
    public MovimentacaoId: number;
    public TipoMovimentacaoMigrarId: TipoMovimentacao;
    public NumeroBeneficio: string;
    public NumeroInstancia: string;

    constructor(movimentacaoId: number = 0){
        if(movimentacaoId > 0)
            this.MovimentacaoId = movimentacaoId;
    }
}
